<app-loading *ngIf="loading"></app-loading>
<div class="panel-header panel-header-sm">
  <div class="row link-header ml-5">
    <div>
      <a class="a-home" routerLink="/home">Home /&nbsp;</a>
    </div>
    <div>
      <a class="text-info" routerLink="/client">Representantes</a>
    </div>
  </div>
</div>

<div class="main-content">
  <!-- INPUT CLIENT -->
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-11">
              <h4 class="card-title" *ngIf="!isEdit">
                Nuevo Representante
              </h4>
              <h4 class="card-title text-warning" *ngIf="isEdit">
                Modificar Representante
              </h4>
            </div>
            <div class="col-1" *ngIf="isEdit">
              <a class="btn btn-round btn-danger btn-icon btn-sm remove" (click)="cancelUpdate($event)"><i
                  class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body">                    
          <!-- DATOS DE REPRESENTANTE -->
          <div class="row">
            <div class="col-12">
              <h6>Datos de Representante</h6> <span>(Obligatorios)</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label>Código Representante</label>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="representative.CodeRepresentative" disabled/>
              </div>
            </div>
            <div class="col-md-3">
              <label>*Nombre Completo</label>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="representative.NameRepresentative" />
              </div>
            </div>
            <div class="col-md-3">
              <label>*Nacionalidad</label>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="representative.NationalityRepresentative" />
              </div>
            </div>
            <!-- <div class="col-md-3">
              <label>*No. Identificación</label>              
              <select class="form-control form-control-sm" [ngModel]="client.clientType" (ngModelChange)="onChangeTypeClient($event)">
                  <option [value]="0">RUC</option>
                  <option [value]="2">EXTRANJERO</option>
              </select>
            </div>
            <div class="col-md-3">
              <label>*Tipo RUC</label>
              <select class="form-control form-control-sm" [ngModel]="client.clientTR" (ngModelChange)="onChangeTypeRUC($event)">
                  <option [value]="1">NATURAL</option>
                  <option [value]="2">JURIDICO</option>
              </select>
            </div> -->
            <div class="col-md-3">
              <label>*No. Identificación</label>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="representative.NumberIdRepresentative" />
              </div>
            </div>
            <div class="col-md-6">
              <label>*Dirección Fiscal</label>
              <div class="form-group">
                <!-- <input type="text" class="form-control" [(ngModel)]="client.clientAddress" /> -->
                <select class="form-control form-control-sm" [ngModel]="client.clientTR" (ngModelChange)="onChangeTypeRUC($event)">
                  <option [value]="1">CALLE MARISCAL FRANCISCO SOLANO LÓPEZ 2732 - BARRIO GENERA DÍAZ</option>
                  <option [value]="2">CALLE ANDRÉS ROJAS, EDIF. WORLD TRADE CENTER, PISO 2 OFICINA C - BARRIO PABLO ROJAS</option>
                  <option [value]="3">AV. AVIADORES DEL CHACO, 2050 EDIF. WORLD TRADE CENTER, TORRE 4 PISO 14 - BARRIO YKUA SATI</option>
              </select>
              </div>
            </div>
            <div class="col-md-6">
              <label>*Dirección Conductor</label>
              <div class="form-group">
                <textarea class="form-control" name="" id="" cols="10" rows="2" [(ngModel)]="representative.AddressDriverRepresentative" placeholder="Ingrese dirección aqui..."></textarea>
              </div>
            </div>
          </div>
          <!-- FIN DATOS DE REPRESENTANTE -->

          <!-- DATOS DE VEHICULO REPRESENTANTE -->
          <hr>
          <div class="row">
            <div class="col-12">
              <h6>Datos del Vehículo</h6>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <label>Tipo de Vehiculo</label>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="representative.TypeVehicle" />
              </div>
            </div>
            <div class="col-md-3">
              <label>Marca Vehiculo</label>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="representative.BrandVehicle" />
              </div>
            </div>
            <div class="col-md-3">
              <label>Modelo del Vehículo</label>
              <div class="form-group">
                <!-- <input type="text" class="form-control" [(ngModel)]="client.clientAddress" /> -->
                <input type="text" class="form-control" [(ngModel)]="representative.ModelVechicle" />
              </div>
            </div>
            <div class="col-md-3">
              <label>Color del Vehículo</label>
              <div class="form-group">
                <!-- <input type="text" class="form-control" [(ngModel)]="client.clientAddress" /> -->
                <textarea class="form-control" name="" id="" cols="10" rows="2" [(ngModel)]="representative.AdditionalVehicle" placeholder="Ingrese color del Vehiculo..."></textarea>
              </div>
            </div>
            <div class="col-md-3">
              <label>No. Identificación Vehiculo</label>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="representative.NumberIdVehicle" />
              </div>
            </div>                      
          </div>
          <!-- FIN DATOS DE CLIENTE FRECUENTE -->

          <hr>
          <div class="row">            
            <div class="col-md-3">
              <div class="form-group mt-4">
                <button class="btn btn-info btn-block" (click)="save()" *ngIf="!isEdit" [disabled]="isDisabled">
                  Guardar
                </button>
                <button class="btn btn-primary btn-block" (click)="update()" *ngIf="isEdit" [disabled]="isDisabled">
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END INPUT CLIENT -->

  <!-- TABLE -->
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-8">
              <h4 class="card-title">Listado de Representantes</h4>
              <h6 class="category">Puedes filtrar por cualquier campo en la caja de texto "Search records"
              </h6>
            </div>
            <div class="col-md-4">
              <button class="btn btn-success btn-sale" style="width: 100%;" (click)="downloadToExcel()"
                [disabled]="isDisabled">
                Descargar Excel
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="dataTables_wrapper">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length" id="datatable_length">
                  <label>
                    Show
                    <select name="datatable_length" aria-controls="datatable" class="form-control form-control-sm"
                      (change)="entriesChange($event)">
                      <option value="10" [selected]="entries == 10">10</option>
                      <option value="25" [selected]="entries == 25">25</option>
                      <option value="50" [selected]="entries == 50">50</option>
                      <option value="-1" [selected]="entries == -1">All</option>
                    </select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label>
                    <input type="search" class="form-control form-control-sm" placeholder="Search records"
                      aria-controls="datatable" (keyup)="filterTable($event)" />
                  </label>
                </div>
              </div>
            </div>
            <ngx-datatable class="bootstrap selection-cell" [columnMode]="'force'" [headerHeight]="50"
              [footerHeight]="50" [rowHeight]="'auto'" [limit]="entries != -1 ? entries : undefined" [rows]="temp"
              (activate)="onActivate($event)" [scrollbarH]="true">
              <ngx-datatable-column name="Código" prop="CodeRepresentative"></ngx-datatable-column>
              <ngx-datatable-column name="Nombre" prop="NameRepresentative"></ngx-datatable-column>
              <ngx-datatable-column name="Nacionalidad" prop="NationalityRepresentative"></ngx-datatable-column>
              <ngx-datatable-column name="Identificación" prop="NumberIdRepresentative"></ngx-datatable-column>
              <ngx-datatable-column name="Dirección F."  prop="FiscalAddressRepresentative"></ngx-datatable-column>
              <ngx-datatable-column name="Dirección Piloto" prop="AddressDriverRepresentative"></ngx-datatable-column>              
              <ngx-datatable-column name="Tipo Vehiculo" prop="TypeVehicle"></ngx-datatable-column>
              <ngx-datatable-column name="Marca" prop="BrandVehicle"></ngx-datatable-column>
              <ngx-datatable-column name="Color Vehiculo" prop="AdditionalVehicle"></ngx-datatable-column>
              <ngx-datatable-column name="Modelo Vehiculo" prop="ModelVechicle"></ngx-datatable-column>
              <ngx-datatable-column name="ID Vehiculo" prop="NumberIdVehicle"></ngx-datatable-column>              
              <ngx-datatable-column [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
                <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                  let-selectFn="selectFn">
                  Acciones
                </ng-template>
                <ng-template ngx-datatable-cell-template let-value="value" let-row="row" let-isSelected="isSelected"
                  let-onCheckboxChangeFn="onCheckboxChangeFn">
                  <!-- <a class="btn btn-round btn-warning btn-icon btn-sm" (click)="billing($event)"
                    ngbTooltip="Facturar" placement="left"><i class="fas fa-sticky-note"></i>
                  </a>
                  <a href="#" class="btn btn-round btn-info btn-icon btn-sm like" (click)="viewFunction($event)"
                    ngbTooltip="Ver" placement="left"><i class="fas fa-eye"></i>
                  </a> -->
                  <a href="#" class="btn btn-round btn-success btn-icon btn-sm edit" (click)="editFunction($event)"
                    ngbTooltip="Editar" placement="left"><i class="fas fa-pencil-alt"></i>
                  </a>
                  <a href="#" class="btn btn-round btn-danger btn-icon btn-sm remove" (click)="deleteFunction($event)"
                    ngbTooltip="Eliminar" placement="left"><i class="fas fa-times"></i>
                  </a>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END TABLE -->
</div>